import React from 'react';
import { useDropGenStore } from '../../stores/dropgenStore';
import { ResearchLab } from './ResearchLab';
import { AutoStoreView } from './autostore/AutoStoreView';

export function MainView() {
  const { activeView } = useDropGenStore();
  const showResearch = !activeView || activeView === 'researchlab';
  const showAutoStore = activeView === 'autostore';

  return (
    <div className="h-full w-full flex flex-col bg-[#0a0a0b] overflow-hidden">
      {/* Keep components mounted, toggle visibility to preserve state */}
      <div className={showResearch ? 'flex-1 flex flex-col overflow-hidden' : 'hidden'}>
        <ResearchLab />
      </div>
      <div className={showAutoStore ? 'flex-1 flex flex-col overflow-hidden' : 'hidden'}>
        <AutoStoreView />
      </div>
    </div>
  );
}
